import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';

import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class VariablesResource {
  constructor(private http: HttpClient) {}

  get(params?: QueryParams): Observable<any> {
    return this.http.get<any>(`${process.env.API_URL}/variables`, { params });
  }
}

((window as any).xplenty as angular.IModule).service('Variable', downgradeInjectable(VariablesResource));
